import { render, staticRenderFns } from "./inspectionItems.vue?vue&type=template&id=3118e530&scoped=true"
import script from "./inspectionItems.vue?vue&type=script&lang=js"
export * from "./inspectionItems.vue?vue&type=script&lang=js"
import style0 from "./inspectionItems.vue?vue&type=style&index=0&id=3118e530&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3118e530",
  null
  
)

export default component.exports